<!--病史-->
<script setup>
import { computed, reactive,watch,ref, onMounted } from "vue";
import upload from "@/components/upload1.vue";
import { useCrfStore } from "@/stores/crf";
import check from "./check.vue";
// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null,
  index:null,
  btnshow:null
});

watch(() => props.formModel, (newVal, oldVal) => {
  console.log(newVal, oldVal, "watch");
})
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 表单验证
const crfStore = useCrfStore();
// index 第几个筛选期
// 表单对象
const model = reactive(props.formModel);
// model[props.type] = 222
// console.log(props.type,"得到的信息");

// const switchYesNo = function(value) {
//   if (value === "是") {
//     return true;
//   } else if (value === "否") {
//     model.fields["若进行过体格检查的检查日期"] = "";
//     model.fields["阳性症状或者体征（请勾选，可多选）"] = [];
//     return false;
//   } else {
//     return null;
//   }
// };
// 图片上传文案
// const uploadHeader = new Headers();
// uploadHeader.append("Authorization", "Bearer uskVPMrb7qncwYF3hbRMwkq");

// const onUploadSuccess = function(res) {
//   trimFileList();
// };

// const onUploadRemove = function(res) {
//   trimFileList();
// };

// const trimFileList = function() {
//   model.fields["简要病史（可拍照上传）"].forEach((item, i) => {
//     if (item.response) {
//       model.fields["简要病史（可拍照上传）"][i] = item.response.data;
//     }
//   });
// };

// 节省代码长度，在模板中使用
const crfFields = computed(() => {

  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
// 肝脏疾病肝炎史选项
const arrs = ['食管胃底静脉曲张','消化道出血','存在血栓','存在腹水','存在脾脏大','其他门脉高压并发症','GGT长期升高','ALP升高','其他肝功异常','血小板减少','脂肪肝','病毒性肝炎史'];

// 无新增功能
if(props.index >= 3){
  // arrs.unshift('无新增')
}

// 选项都已经加好，一会回来写点击逻辑
// 肝脏疾病 (点击无新增清除所有已选)
watch(()=>model.fields[`${props.type}`]?.['肝脏疾病史（可多选）'],(e)=>{
  console.log(e)
  if(!e) return
  if (e[e.length - 1] == '无新增') {
    let length = e.length
    for (let index = 0; index < length-1; index++) {
      model.fields[`${props.type}`]?.['肝脏疾病史（可多选）'].shift() 
    } 
  }else{
    let index = model.fields[`${props.type}`]?.['肝脏疾病史（可多选）'].indexOf('无新增')
    if(index > -1) model.fields[`${props.type}`]?.['肝脏疾病史（可多选）'].splice(index,1)
  }

});

// psvd伴随疾病
watch(()=>model.fields[`${props.type}`]?.['PSVD相关伴随疾病'],(e)=>{
  console.log(e)

  if(!e) return
  if (e[e.length - 1] == '无新增') {
    let length = e.length
    for (let index = 0; index < length-1; index++) {
      model.fields[`${props.type}`]?.['PSVD相关伴随疾病'].shift() 
    } 
  }else{
    let index = model.fields[`${props.type}`]?.['PSVD相关伴随疾病'].indexOf('无新增')
    if(index > -1) model.fields[`${props.type}`]?.['PSVD相关伴随疾病'].splice(index,1)
  }

});
// 症状和体征

watch(()=>model.fields[`${props.type}`]?.['阳性症状或者体征（请勾选，可多选）'],(e)=>{
  console.log(e)

  if(!e) return
  if (e[e.length - 1] == '无新增') {
    let length = e.length
    for (let index = 0; index < length-1; index++) {
      model.fields[`${props.type}`]?.['阳性症状或者体征（请勾选，可多选）'].shift() 
    } 
  }else{
    let index = model.fields[`${props.type}`]?.['阳性症状或者体征（请勾选，可多选）'].indexOf('无新增')
    if(index > -1) model.fields[`${props.type}`]?.['阳性症状或者体征（请勾选，可多选）'].splice(index,1)
  }

});
const title = computed(()=>{
  if(props.index == 2 || props.index>13){
     return '病史'
  }else if(props.index == 1 ){ 
    return '计划外病史'
  }else if(props.index == 3 && !props.btnshow) {
     return '筛选期至V0期病史补充'
  }else if(props.index > 3){
    return `V${props.index - 4}期至V${props.index - 3}期病史补充`
  }
})

onMounted(()=>{
  console.log(props.formModel.checkdata,'checkdata')
})



;
</script>
<template>
  <template v-if="crfFields">
    <div class="title_up">
      <!-- <h2 v-if="props.index == 2 || props.index>13">病史</h2>
      <h2 v-else-if="props.index == 1">计划外病史</h2>
      <h2 v-else-if="props.index == 3 && !props.btnshow">筛选期至V0期病史补充</h2>
      <h2 v-else-if="props.index > 3"> V{{ props.index - 4 }}期至V{{ props.index - 3 }}期病史补充</h2> -->
      <!-- <h2 v-if="crfFormses[crfFormIndex].name =='筛选期（肝穿前96周内资料完整点）±2周'">病史</h2> -->
      <!-- <h2 v-else>补充病史（筛选期至V{{crfFormIndex}}期病史补充）</h2> -->
       <h2>{{ title }}</h2>
      <upload :type="props.type" :data="model" name="bs" btn_name="可同时拍摄病史记录上传"></upload>
      <check :period="props.type" :text="title" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <!-- 肝脏疾病史(新增和适用) -->

    <el-form-item label="肝脏疾病史是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
    
      <el-radio-group v-if="notScreen" v-model="crfFields['肝脏疾病史是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['肝脏疾病史是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增肝脏疾病史':'肝脏疾病史'"  v-if="crfFields" class="redStar">
          <el-radio-group v-model="crfFields['是否新增肝脏疾病史']" v-if="notScreen" >
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
        
          <template v-if="crfFields['是否新增肝脏疾病史'] == '是' || !notScreen">
            <el-form-item label="" :prop="itemProp('肝脏疾病史（可多选）')" :rules="crfStore.checkboxRules('肝脏疾病史（可多选）')">
              <el-checkbox-group v-model="crfFields['肝脏疾病史（可多选）']">
                <template v-for="(item, index) in arrs" :key="index">
                  <div class="flex" style="margin-top: 10px;">
                    <el-checkbox :label="item"></el-checkbox>
                    <div class="date_one" v-if="item != '其他门脉高压并发症' &&  crfFields['肝脏疾病史（可多选）']?.includes(item) && (props.index >= 3?index >0 :index >-1 )" style="display: flex;">
                        <p class="p_frist">{{props.index == 2?'首次发现日期':'发现时间'}}</p>
                        <el-date-picker 
                          v-model="crfFields[`${item}首次发现时间`]"
                          type="date"
                          placeholder="请选择日期"
                          size="default"
                        />
                    </div> 
                  </div>
                <!-- 选中病毒性肝炎史 -->
                  <div class="sanjitxt" v-if="crfFields['肝脏疾病史（可多选）']?.includes('病毒性肝炎史') && item == '病毒性肝炎史'">
                    <el-checkbox-group v-model="crfFields['肝脏疾病史（可多选）']">
                      <el-checkbox label="乙肝" prop="乙肝"></el-checkbox>
                      <el-checkbox label="丙肝" prop="丙肝"></el-checkbox>
                    </el-checkbox-group>
                  </div>  
                  <!-- 选中门脉高压并发症 -->
                  <div class="sanjitxt" v-if="crfFields['肝脏疾病史（可多选）']?.includes('其他门脉高压并发症') && item == '其他门脉高压并发症' ">
                    <!-- <el-input v-model="crfFields['伴随疾病多选其他门脉高压txt']" placeholder="请输入其他门脉高压并发症"></el-input> -->
                    <el-checkbox-group v-model="crfFields['其他门脉高压并发症子级']">
                      <div class="flex" style="margin-top: 10px;">
                        <el-checkbox label="肝肾综合征" prop="肝肾综合征"></el-checkbox>
                          <div class="date_one" v-if="crfFields['其他门脉高压并发症子级']?.includes('肝肾综合征')" style="display: flex;">
                            <p class="p_frist">首次发现日期</p>
                            <el-date-picker 
                              v-model="crfFields[`其他门脉高压并发症子级_肝肾综合征`]"
                              type="date"
                              placeholder="请选择日期"
                              size="default"
                            />
                        </div> 
                      </div>
                      <div class="flex" style="margin-top: 10px;">
                        <el-checkbox label="肝肺综合征" prop="肝肺综合征"></el-checkbox>
                          <div class="date_one" v-if="crfFields['其他门脉高压并发症子级']?.includes('肝肺综合征')" style="display: flex;">
                            <p class="p_frist">首次发现日期</p>
                            <el-date-picker 
                              v-model="crfFields[`其他门脉高压并发症子级_肝肺综合征`]"
                              type="date"
                              placeholder="请选择日期"
                              size="default"
                            />
                        </div> 
                      </div>
                      <div class="flex" style="margin-top: 10px;">
                        <el-checkbox label="肝性脑病" prop="肝性脑病"></el-checkbox>
                          <div class="date_one" v-if="crfFields['其他门脉高压并发症子级']?.includes('肝性脑病')" style="display: flex;">
                            <p class="p_frist">首次发现日期</p>
                            <el-date-picker 
                              v-model="crfFields[`其他门脉高压并发症子级_肝性脑病`]"
                              type="date"
                              placeholder="请选择日期"
                              size="default"
                            />
                        </div> 
                      </div>
                    </el-checkbox-group>


                  </div>  
                </template>
                
              </el-checkbox-group>
            </el-form-item>
          </template>
        </el-form-item>
      </template>



    <!-- 伴随疾病(新增和适用) -->
    <el-form-item label="伴随疾病是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['伴随疾病是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['伴随疾病是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增伴随疾病':'伴随疾病'"  v-if="crfFields" class="redStar">
          <el-radio-group v-model="crfFields['伴随疾病']" v-if="notScreen">
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>

          <template v-if="crfFields['伴随疾病'] == '是' || !notScreen " >
            <el-form-item label="" :prop="itemProp('伴随疾病多选')" :rules="crfStore.checkboxRules('伴随疾病多选')">
                <el-checkbox-group v-model="crfFields['伴随疾病多选']" >
                  <el-checkbox label="高血压" prop="高血压"></el-checkbox>
                  <el-checkbox label="高血脂" prop="高血脂"></el-checkbox>
                  <el-checkbox label="糖尿病" prop="糖尿病"></el-checkbox>
                  <el-checkbox label="其他" prop="其他"></el-checkbox> 
                  <el-checkbox label="无伴随疾病" prop="无伴随疾病"></el-checkbox> 

                </el-checkbox-group>
                <el-input v-if="crfFields['伴随疾病多选'] ?.includes('其他')" v-model="crfFields['伴随疾病多选其他txt']" type="textarea"
                          placeholder="请输入伴随疾病" rows="4">
                </el-input>
              </el-form-item>

          </template>
        </el-form-item>
      </template>

    <!-- 脾切除以外手术 -->
    <el-form-item label="脾切除以外手术史是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['脾切除以外手术史是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['脾切除以外手术史是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增脾切除以外手术史':'脾切除以外手术史'" v-if="crfFields" class="redStar">
          <el-radio-group v-model="crfFields['是否新增脾切除以外手术史']" v-if="notScreen">
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
          <template v-if="crfFields['是否新增脾切除以外手术史'] == '是' || !notScreen">

            <el-form-item label="" :prop="itemProp('脾切除以外手术史')" :rules="crfStore.textRules('脾切除以外手术史',true)">
              <el-input v-model="crfFields['脾切除以外手术史']"  type="textarea" placeholder="请输入脾切除以外手术史"></el-input>
            </el-form-item>
          </template>
        </el-form-item>
      </template>
    <!-- 饮酒史 -->
    <el-form-item label="饮酒史是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['饮酒史是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['饮酒史是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增饮酒史':'饮酒史'"  v-if="crfFields" class="redStar">
          <el-radio-group v-model="crfFields['饮酒史']" v-if="notScreen" >
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
          <template v-if="crfFields['饮酒史'] == '是' || !notScreen">

            <el-form-item label="" :prop="itemProp('饮酒史txt')" :rules="crfStore.textRules('饮酒史',true)">
              <el-input  v-model="crfFields['饮酒史txt']" type="textarea"
                  placeholder="请输入饮酒史" rows="4">
              </el-input>
          </el-form-item>
          </template>
        </el-form-item>
      </template>
    <!-- psvd 相关伴随疾病 -->
    <el-form-item label="PSVD相关伴随疾病是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['PSVD相关伴随疾病是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['PSVD相关伴随疾病是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增PSVD相关伴随疾病':'PSVD相关伴随疾病'"  v-if="crfFields" class="redStar">

          <el-radio-group v-model="crfFields['PSVD相关伴随疾病(新增)']" v-if="notScreen">
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
          <template v-if="crfFields['PSVD相关伴随疾病(新增)'] == '是' || !notScreen">
            <el-form-item label="" :prop="itemProp('PSVD相关伴随疾病')" :rules="crfStore.checkboxRules('PSVD相关伴随疾病')">
              <el-checkbox-group v-model="crfFields['PSVD相关伴随疾病']" >
                <!-- <el-checkbox v-if="props.index >= 3" label="无新增" prop="无新增"></el-checkbox> -->
                <el-checkbox label="血液系统"></el-checkbox>
                    <div class="sanjitxt" v-if="crfFields['PSVD相关伴随疾病']?.includes('血液系统')">
                      <el-checkbox-group  v-model="crfFields['血液系统多选']">
                        <el-checkbox label="再生障碍性贫血" prop="再生障碍性贫血"></el-checkbox>
                        <el-checkbox label="骨髓增生性疾病" prop="骨髓增生性疾病"></el-checkbox>
                        <el-checkbox label="霍奇金淋巴瘤" prop="霍奇金淋巴瘤"></el-checkbox>
                        <el-checkbox label="多发性骨髓瘤" prop="多发性骨髓瘤"></el-checkbox>
                        <el-checkbox label="巨球蛋白血病" prop="巨球蛋白血病"></el-checkbox>
                        <el-checkbox label="其他" prop="其他"></el-checkbox>
                      </el-checkbox-group>
                      <el-input v-if="crfFields['血液系统多选']?.includes('其他')" v-model="crfFields['血液系统_其他txt']" placeholder="请输入"></el-input>
                    </div>
                <el-checkbox label="高凝状态"></el-checkbox>
                    <div class="sanjitxt" v-if="crfFields['PSVD相关伴随疾病']?.includes('高凝状态')">
                      <el-checkbox-group  v-model="crfFields['高凝状态多选']">
                        <el-checkbox label="蛋白质C/S缺乏" prop="蛋白质C/S缺乏"></el-checkbox>
                        <el-checkbox label="因子Ⅱ或Ⅴ基因突变" prop="因子Ⅱ或Ⅴ基因突变"></el-checkbox>
                        <el-checkbox label="抗磷脂综合征" prop="抗磷脂综合征"></el-checkbox>
                        <el-checkbox label="ADAMTS13缺乏" prop="ADAMTS13缺乏"></el-checkbox>
                        <el-checkbox label="其他" prop="其他"></el-checkbox>
                      </el-checkbox-group>
                      <el-input v-if="crfFields['高凝状态多选']?.includes('其他')" v-model="crfFields['高凝状态_其他txt']" placeholder="请输入"></el-input>
                    </div>
                <el-checkbox label="免疫疾病"></el-checkbox>
                    <div class="sanjitxt" v-if="crfFields['PSVD相关伴随疾病']?.includes('免疫疾病')">
                      <el-checkbox-group  v-model="crfFields['免疫疾病多选']">
                        <el-checkbox label="普通变异型免疫缺陷病（显著不明原因的低丙种球蛋⽩⾎症，细菌感染和疫苗接种后不能产⽣特异性抗体）" 
                            prop="普通变异型免疫缺陷病（显著不明原因的低丙种球蛋⽩⾎症，细菌感染和疫苗接种后不能产⽣特异性抗体）"></el-checkbox>
                        <el-checkbox label="⾃身免疫性肝炎" prop="⾃身免疫性肝炎"></el-checkbox>
                          <el-checkbox label="系统性红斑狼疮" prop="系统性红斑狼疮"></el-checkbox>
                          <el-checkbox label="硬皮病" prop="硬皮病"></el-checkbox>
                          <el-checkbox label="类⻛湿性关节炎" prop="类⻛湿性关节炎"></el-checkbox>
                          <el-checkbox label="HIV" prop="HIV"></el-checkbox>
                          <el-checkbox label="乳糜泻" prop="乳糜泻"></el-checkbox>
                          <el-checkbox label="炎症性肠病" prop="炎症性肠病"></el-checkbox>
                          <el-checkbox label="其他" prop="其他"></el-checkbox>
                        </el-checkbox-group>
                        <el-input v-if="crfFields['免疫疾病多选']?.includes('其他')" v-model="crfFields['免疫疾病_其他txt']" placeholder="请输入"></el-input>
                    </div>

                <el-checkbox label="感染"></el-checkbox>
                    <div class="sanjitxt" v-if="crfFields['PSVD相关伴随疾病']?.includes('感染')">
                      <el-checkbox-group  v-model="crfFields['感染多选']">
                        <el-checkbox label="反复胃肠道感染"></el-checkbox>
                        <el-checkbox label="胆系感染"></el-checkbox>
                        <el-checkbox label="其他感染"></el-checkbox>
                      </el-checkbox-group>
                      <el-input v-if="crfFields['感染多选']?.includes('其他感染')" v-model="crfFields['感染多选_其他感染txt']" placeholder="请输入其他感染"></el-input>
                    </div>
              
                <el-checkbox label="药物及毒物接触史"></el-checkbox>
                    <div class="sanjitxt" v-if="crfFields['PSVD相关伴随疾病']?.includes('药物及毒物接触史')">
                      <el-checkbox-group  v-model="crfFields['药物及毒物接触史']">
                        <!-- <el-checkbox label="中药"></el-checkbox> -->
                        <div class="zhongyao_up">
                          <el-checkbox label="中药"></el-checkbox>
                          <upload :type="props.type" :data="model" name="bs_zy" btn_name="中药方拍照上传"></upload>
                        </div>
                            <div class="sanjitxt" v-if="crfFields['药物及毒物接触史']?.includes('中药')">
                                <el-checkbox-group  v-model="crfFields['药物及毒物接触史多选_中药']">
                                  <el-checkbox label="土三七"></el-checkbox>
                                  <el-checkbox label="补骨脂"></el-checkbox>
                                  <el-checkbox label="何首乌"></el-checkbox>
                                  <el-checkbox label="其他"></el-checkbox>
                                
                                </el-checkbox-group>
                                <el-input v-if="crfFields['药物及毒物接触史多选_中药']?.includes('其他')" v-model="crfFields['药物及毒物接触史多选_中药_其他txt']" placeholder="请输入"></el-input>
                            </div>
                        <el-checkbox label="抗肿瘤药物"></el-checkbox>
                            <div class="sanjitxt" v-if="crfFields['药物及毒物接触史']?.includes('抗肿瘤药物')">
                                <el-checkbox-group  v-model="crfFields['药物及毒物接触史多选_抗肿瘤药物']">
                                  <el-checkbox label="奥沙利铂"></el-checkbox>
                                  <el-checkbox label="化疗方案"></el-checkbox>
                                      <el-input v-if="crfFields['药物及毒物接触史多选_抗肿瘤药物']?.includes('化疗方案')" v-model="crfFields['药物及毒物接触史多选_抗肿瘤药物_化疗方案txt']" placeholder="请输入"></el-input>
                                  <el-checkbox label="其他"></el-checkbox>
                                      <el-input v-if="crfFields['药物及毒物接触史多选_抗肿瘤药物']?.includes('其他')" v-model="crfFields['药物及毒物接触史多选_抗肿瘤药物_其他txt']" placeholder="请输入"></el-input>
                                </el-checkbox-group>
                            </div>
                        <el-checkbox label="其他可疑药物"></el-checkbox>
                          <div class="sanjitxt" v-if="crfFields['药物及毒物接触史']?.includes('其他可疑药物')">
                              <el-checkbox-group  v-model="crfFields['药物及毒物接触史多选_其他可疑药物']">
                                  <el-checkbox label="去羟肌苷"></el-checkbox>
                                  <el-checkbox label="硫唑嘌呤"></el-checkbox>
                                  <el-checkbox label="硫鸟嘌呤"></el-checkbox>
                                  <el-checkbox label="补充其他可疑药物或毒物"></el-checkbox>
                                  <el-input v-if="crfFields['药物及毒物接触史多选_其他可疑药物']?.includes('补充其他可疑药物或毒物')" v-model="crfFields['药物及毒物接触史多选_补充其他可疑药物或毒物_其他txt']" placeholder="请输入"></el-input>
                              </el-checkbox-group>
                          </div>
                      </el-checkbox-group>
                    </div>
                
                <el-checkbox label="遗传代谢"></el-checkbox>
                    <div class="sanjitxt" v-if="crfFields['PSVD相关伴随疾病']?.includes('遗传代谢')">
                      <el-checkbox-group  v-model="crfFields['遗传代谢多选']">
                        <el-checkbox label="特纳⽒综合症"  prop="特纳⽒综合症"></el-checkbox>
                        <el-checkbox label="Adams-Oliver综合征" prop="Adams-Oliver综合征"></el-checkbox>
                        <el-checkbox label="TERT突变" prop="TERT突变"></el-checkbox>
                        <el-checkbox label="囊性纤维化" prop="囊性纤维化"></el-checkbox>
                        <el-checkbox label="家族性病例" prop="家族性病例"></el-checkbox>
                        <el-checkbox label="其他" prop="其他"></el-checkbox>
                      </el-checkbox-group>
                      <el-input v-if="crfFields['遗传代谢多选']?.includes('其他')" v-model="crfFields['遗传代谢_其他txt']" placeholder="请输入"></el-input>
                    </div>
                <el-checkbox label="其他"></el-checkbox> 
                    <!-- <div > -->
                      <!-- <p class="c_title">其他</p> -->
                    <el-input class="sanjitxt" v-if="crfFields['PSVD相关伴随疾病']?.includes('其他')"  v-model="crfFields['PSVD相关伴随疾病其他txt']" placeholder="请输入其他疾病"></el-input>
                  <!-- </div> -->
              </el-checkbox-group>
          </el-form-item>
          </template>
        </el-form-item>
      </template>
    <h3>{{notScreen?'症状和体征':'症状和体征'}}</h3>
    <!-- <el-form-item label="体格检查时间" :prop="itemProp('体格检查日期')" class="redStar">
      <el-date-picker v-model="crfFields['体格检查日期']" type="date" placeholder="选择体格检查时间" value-format="YYYY-MM-DD" />
    </el-form-item> -->
    <!-- 阳性症状或者体征 -->
    <el-form-item label="阳性症状或者体征是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['阳性症状或者体征是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['阳性症状或者体征是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增阳性症状或者体征（请勾选，可多选）':'阳性症状或者体征（请勾选，可多选）'" class="redStar">
          <el-radio-group v-model="crfFields['是否新增阳性症状或者体征']" v-if="notScreen">
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
          <template v-if="crfFields['是否新增阳性症状或者体征'] == '是' || !notScreen">
            <el-form-item label="" :prop="itemProp('阳性症状或者体征（请勾选，可多选）')" :rules="crfStore.checkboxRules('阳性症状或者体征')">
              <el-checkbox-group v-model="crfFields['阳性症状或者体征（请勾选，可多选）']" prop="阳性症状或者体征（请勾选，可多选）" >
                <!-- <el-checkbox v-if="props.index >= 3" label="无新增" prop="无新增"></el-checkbox> -->
                <el-checkbox label="肝性脑病" prop="肝性脑病" ></el-checkbox>
                  <div  style="padding-left: 20px;">
                      <el-form-item label="肝性脑病级别" class="redStar" :prop="itemProp('肝性脑病级别')" :rules="crfStore.radioRules('肝性脑病级别')" v-if="crfFields['阳性症状或者体征（请勾选，可多选）']?.includes('肝性脑病')">
                          <el-radio-group v-model="crfFields['肝性脑病级别']" >
                            <el-radio label="1级" prop="1级"></el-radio>
                            <el-radio label="2级" prop="2级"></el-radio>
                            <el-radio label="3级" prop="3级"></el-radio>
                            <el-radio label="4级" prop="4级"></el-radio>
                            <el-radio label="未测" prop="未测"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                  </div>
                <el-checkbox label="呕血" prop="呕血"></el-checkbox>
                <el-checkbox label="黑便" prop="黑便"></el-checkbox>
                <el-checkbox label="皮肤巩膜黄染" prop="皮肤巩膜黄染"></el-checkbox>
                <el-checkbox label="脾肿大" prop="脾肿大"></el-checkbox>
                <el-checkbox label="肝脏可触及" prop="肝脏可触及"></el-checkbox>
                <el-checkbox label="贫血" prop="贫血"></el-checkbox>
                <el-checkbox label="腹壁静脉曲张" prop="腹壁静脉曲张"></el-checkbox>
                <el-checkbox label="腹水" prop="腹水"></el-checkbox>
                  <div style="padding-left: 20px;">
                      <el-radio-group v-model="crfFields['腹水']" v-if="  crfFields['阳性症状或者体征（请勾选，可多选）']?.includes('腹水')">
                        <el-radio label="轻" prop="轻"></el-radio>
                        <el-radio label="中" prop="中"></el-radio>
                        <el-radio label="重" prop="重"></el-radio>
                        <el-radio label="未测" prop="未测"></el-radio>
                      </el-radio-group>
                  </div>
                <el-checkbox label="水肿" prop="水肿"></el-checkbox>
                <el-checkbox label="腹胀"></el-checkbox>
                <el-checkbox label="其他"></el-checkbox>
                <el-input v-if="crfFields['阳性症状或者体征（请勾选，可多选）']?.includes('其他')"  v-model="crfFields['阳性症状或者体征_其他txt']" placeholder="请输入"></el-input>
              </el-checkbox-group>
            </el-form-item>
          </template>
        </el-form-item>
      </template>
    
    <template v-if="!notScreen">
      <div style="display: flex; align-items: center;">
        <h2>首次临床诊断</h2>
        <check :period="props.type" text="首次临床诊断" :data="model" v-if="model.checkdata.ischeck == '是'"></check>

      </div>
      <el-form-item label="首次临床诊断时间"  v-if="crfFields" class="redStar">
        <el-date-picker 
        v-model="crfFields[`首次临床诊断时间`]"
        type="date"
        placeholder="请选择日期"
        size="default"
        />
      </el-form-item>
      <el-form-item label="首次临床诊断"  v-if="crfFields" class="redStar">
          <el-input v-model="crfFields['首次临床诊断']" type="textarea"
                    placeholder="请输入首次临床诊断" rows="4">
          </el-input>
      </el-form-item>

    </template>
    
  </template>
</template>

<style lang="scss" scoped>
 .title_up{
  position: relative;
  display:flex;

}
.c_title{
  width: 100%;
  margin: 0;
}
.el-radio-group{
  display: block;
  width: 100%;
}
.el-checkbox {
  // margin-top: 10px;
  display: flex;
  // text-align: center;
}
.sanjitxt{
  padding-left: 30px;
}
.zhongyao_up{
  display: flex;
  // align-items: center;
 ::v-deep .btn_fiexd{
  margin-top: 5px;
  button{
    width: 110px;
    height: 24px;
  }
 }
}
.first_date{
  p{
    width: 90px;
    color: #606266;
    font-size: 15px;
    margin: 0;
  }
  display: flex;
  
}
.date_one{
    margin-left: 20px;
    .p_frist{
      font-size: 14px;
       margin:15px 10px 0 -15px;
    }
  }
</style>